export default {
    title: 'テンプレート',
    createTemplate: 'テンプレートを作成',
    searchPlaceholder: 'テンプレートを検索...',
    showingResults: '{count}件の結果を表示',
    total: '合計',
    sort: '並び替え',
    all: 'すべて',
    myTemplates: 'マイテンプレート',
    sharedTemplates: '共有テンプレート',
    favorites: 'お気に入り',
    allRegions: 'すべての地域',

    sortByUpdated: '最近更新',
    sortByCreated: '最近作成',
    sortByNameAsc: '名前 (A-Z)',
    sortByNameDesc: '名前 (Z-A)',
    types: { PATENT_APPLICATION: '特許出願', INVENTION_DISCLOSURE: '発明開示書', OFFICE_ACTION_RESPONSE: '拒絶理由対応' },
    regions: { all: 'すべての地域', USPTO: 'USPTO', EPO: 'EPO', PCT: 'PCT', CNIPA: 'CNIPA', JPO: 'JPO', KIPO: 'KIPO' },
    technologyArea: { general: '一般', electrical: '電気', mechanical: '機械', chemical: '化学', software: 'ソフトウェア', biotech: 'バイオテクノロジー' },
    preview: 'プレビュー',
    edit: '編集',
    editInfo: '情報編集',
    editContent: 'コンテンツ編集',
    duplicate: '複製',
    delete: '削除',
    favorite: 'お気に入りに追加',
    unfavorite: 'お気に入りから削除',
    setDefault: 'デフォルトに設定',
    unsetDefault: 'デフォルトを解除',
    defaultTemplate: 'デフォルトテンプレート',
    moreActions: 'その他の操作',
    share: '共有',
    shareTemplate: '共有',
    source: 'ソース', system: 'システム', custom: 'カスタム', systemTemplate: 'システムテンプレート',
    name: '名前', type: 'タイプ', region: '地域', updated: '更新日時', actions: '操作',
    messages: {
        fetchListFailed: 'テンプレートリストの取得に失敗しました',
        fetchDetailFailed: 'テンプレート詳細の取得に失敗しました',
        createSuccess: 'テンプレートを作成しました',
        createFailed: 'テンプレートの作成に失敗しました',
        updateSuccess: 'テンプレートを更新しました',
        updateFailed: 'テンプレートの更新に失敗しました',
        deleteSuccess: 'テンプレートを削除しました',
        deleteFailed: 'テンプレートの削除に失敗しました',
        duplicateSuccess: 'テンプレートを複製しました',
        duplicateFailed: 'テンプレートの複製に失敗しました',
        favoriteSuccess: 'お気に入りに追加しました',
        favoriteFailed: 'お気に入りへの追加に失敗しました',
        unfavoriteSuccess: 'お気に入りから削除しました',
        unfavoriteFailed: 'お気に入りからの削除に失敗しました',
        setDefaultSuccess: 'デフォルトテンプレートを設定しました',
        setDefaultFailed: 'デフォルトテンプレートの設定に失敗しました',
        unsetDefaultSuccess: 'デフォルトテンプレートを解除しました',
        unsetDefaultFailed: 'デフォルトテンプレートの解除に失敗しました',
        shareSuccess: '共有しました',
        shareFailed: '共有に失敗しました',
        deleteShareSuccess: '共有を削除しました',
        deleteShareFailed: '共有の削除に失敗しました',
        updateShareSuccess: '共有を更新しました',
        updateShareFailed: '共有の更新に失敗しました',
    },

    // Share Dialog
    shareDialog: {
        title: 'テンプレートを共有',
        shareSettings: '共有設定',
        shareType: '共有タイプ',
        companyShare: '会社',
        companyShareName: '当社',
        personalShare: '個人',
        companyShareDesc: '会社の全メンバーと共有',
        personalShareDesc: '特定のユーザーと共有',
        selectUser: 'ユーザーを選択',
        searchUser: 'ユーザーを検索',
        permission: '権限',
        readOnly: '読み取り専用',
        editable: '編集可能',
        expiresAt: '有効期限',
        neverExpires: '無期限',
        expiry7Days: '7日間',
        expiry15Days: '15日間',
        expiry30Days: '30日間',
        setExpireTime: '有効期限を設定',
        sharedBy: '共有者',
        sharedTo: '共有先',
        sharedAt: '共有日時',
        shareList: '共有リスト',
        noShares: '共有がありません',
        createShare: '共有を作成',
        deleteShareConfirm: 'この共有を削除してもよろしいですか？',
        cancel: 'キャンセル',
        confirm: '確認',
        save: '保存',
    },
    noTemplates: 'テンプレートがありません', noTemplatesDesc: '最初のテンプレートを作成してください', noResults: '一致するテンプレートが見つかりません', noResultsDesc: '検索条件またはフィルターを調整してください',
    dialog: {
        createTemplate: 'テンプレートを作成',
        createTemplateDesc: 'タイプを選択し名前を設定してプロフェッショナルなテンプレートを作成',
        templateName: 'テンプレート名',
        templateNamePlaceholder: 'テンプレート名を入力',
        templateType: 'テンプレートタイプ',
        creationMethod: '作成方法',
        blankTemplate: '空白テンプレート',
        blankTemplateDesc: 'ゼロから作成',
        copyFromExisting: 'テンプレートをコピー',
        copyFromExistingDesc: '既存のテンプレートに基づいて作成',
        referencePatentFullTemplate: '参考特許から生成',
        referencePatentFullTemplateDesc: '参考特許全文からテンプレートを作成',
        referenceSourceTitle: '参考ソース',
        referenceSourceDesc: '参考特許を選択または参考文書をアップロードし、テンプレート生成をクリックすると自動で文体を抽出して作成します。',
        referenceGranularity: '粒度',
        referenceGranularityGeneral: '汎用型',
        referenceGranularityGeneralDesc: '構成を簡潔にし、本文は標準的な定型表現を中心にします',
        referenceGranularityDetailed: '詳細型',
        referenceGranularityDetailedDesc: 'より細かなプレースホルダーと入力式テンプレートを保持します',
        referencePatents: '参考特許',
        referencePatentInputPlaceholder: '特許番号を貼り付け。複数の場合は改行、カンマ、セミコロンで区切ります',
        referenceDocuments: '参考文書',
        referenceDocumentUploadTitle: '参考特許または文体文書をアップロード',
        referenceDocumentUploadHint: 'PDF、Wordに対応',
        referenceFileStatusPending: '解析待ち',
        referenceFileStatusProcessing: '解析中',
        referenceFileStatusCompleted: '解析完了',
        referenceFileStatusFailed: '解析失敗',
        referenceFileStatusUnknown: '状態不明',
        referenceFilesProcessingHint: '参考文書を解析中です。すべて完了してからテンプレートを生成してください。',
        referenceFilesFailedHint: '参考文書の解析に失敗しました。失敗したファイルを削除して再度アップロードしてください。',
        referenceFilesNotReadyHint: '参考文書の準備がまだ完了していません。準備完了後にテンプレートを生成してください。',
        referenceSearch: '検索して追加',
        referenceSearching: '検索中',
        referenceRemove: '削除',
        referenceElapsed: '経過 {time}',
        referenceEstimatedTime: '通常1〜2分かかります',
        referenceGenerate: 'テンプレート生成',
        referenceGenerating: '生成中...',
        referenceProgressSubmitting: 'タスク送信',
        referenceProgressAnalyzing: '参考文体を分析',
        referenceProgressPreviewing: 'テンプレートプレビュー生成',
        referenceProgressConfirming: 'テンプレート作成',
        referenceSubmittingStatus: '参考文体抽出タスクを送信中...',
        referenceAnalyzingStatus: '参考文体を分析中...',
        referenceWaitingStatus: '分析タスクの開始を待機中...',
        referenceExtractionFailed: '文体ルールの抽出に失敗しました',
        referenceTemplateGenerated: 'テンプレートを生成しました',
        referenceGenerateFailed: 'テンプレート生成に失敗しました',
        referenceNoPatentFound: '利用可能な参考特許が見つかりません',
        referencePatentDetailFailed: '参考特許詳細の読み込みに失敗しました',
        referencePatentsAdded: '{count}件の参考特許を追加しました',
        referenceMaxPatentsExceeded: '参考特許は最大{max}件まで対応しています',
        referenceMaxFilesExceeded: '参考文書は最大{max}件まで対応しています',
        referencePatentSearchFailed: '参考特許の検索に失敗しました',
        selectBaseTemplate: 'ベーステンプレートを選択',
        noTemplatesAvailable: '利用可能なテンプレートがありません',
        createAndEdit: '作成して編集',
        sections: 'セクション',
        cancel: 'キャンセル',
        unsavedChangesTitle: '未保存の変更',
        unsavedChangesMessage: '未保存の変更があります。閉じてもよろしいですか？変更内容は失われます。',
        discardChanges: '変更を破棄',
        continueEditing: '編集を続ける',
        lastUpdated: '最終更新',
        noContent: 'コンテンツなし',
        // Level selection (Super Admin only)
        level: '可視性',
        adminOnly: '管理者のみ',
        systemLevel: 'システムレベル',
        userLevel: 'ユーザーレベル',
        systemLevelDesc: 'すべてのユーザーに表示',
        userLevelDesc: '自分のみ表示',
        // Description
        description: '説明',
        descriptionPlaceholder: 'このテンプレートの目的と使用例を簡潔に説明してください...',
        optional: 'オプション',
        // Word import
        importFromWord: 'Wordからインポート',
        importFromWordDesc: '.docxからセクションを抽出',
        uploadWordFile: 'Word文書をアップロード',
        uploadWordAction: '.docxファイルをここにドロップまたはクリックしてアップロード',
        uploadWordHint: '見出しスタイルを含む.docxファイルに対応',
        parsing: '文書を解析中...',
        parseSuccess: '{count}個のセクションを解析しました',
        parseFailed: '文書の解析に失敗しました',
        parsedSections: '解析済みセクション ({count})',
    },

    // Template Editor
    templateEditor: {
        back: '戻る',
        untitledTemplate: '無題のテンプレート',
        clickToEdit: 'クリックして編集',
        templateType: 'テンプレートタイプ',
        region: '地域',
        technologyArea: '技術分野',
        from: 'ソース',
        visibility: '表示',
        private: 'プライベート',
        library: 'ライブラリ',
        saveTemplate: 'テンプレートを保存',
        aiInstructions: 'AI 指示',
        aiInstructionsDesc: '各セクションにAI指示を設定し、要件に合ったコンテンツ生成をガイドします。',
        addSection: 'セクションを追加',
        sectionTitle: 'セクションタイトル',
        insert: '挿入',
        delete: '削除',
        selectInstruction: '指示を選択',
        aiInstructionPlaceholder: 'このセクションのAI指示を入力...',
        description: '説明',
        descriptionPlaceholder: 'テンプレートの目的と主要な機能を説明してください...',
        // Level
        level: '可視性',
        // Collapse/Expand buttons
        collapseAll: 'すべて折りたたむ',
        expandAll: 'すべて展開',
        // Section prompt editor
        aiInstruction: 'AI 指示',
        linkedInstruction: 'リンク済み指示',
        sectionInstruction: 'セクション指示',
        words: '語',
        fromLibrary: 'ライブラリから選択',
        remove: '削除',
        required: '必須',
        // Section names
        sections: {
            title: 'タイトル',
            crossReference: '関連出願の相互参照',
            fieldOfInvention: '発明の分野',
            background: '背景技術',
            summary: '発明の概要',
            briefDescription: '図面の簡単な説明',
            detailedDescription: '発明の詳細な説明',
            claims: '請求の範囲',
            abstract: '要約',
            newSection: '新しいセクション',
        },
        types: {
            patentApplication: '特許出願',
            inventionDisclosure: '発明開示書',
            officeActionResponse: '拒絶理由対応',
        },
        messages: {
            nameRequired: 'テンプレート名を入力してください',
            updateSuccess: 'テンプレートを更新しました',
            saveSuccess: 'テンプレートを保存しました',
            saveFailed: 'テンプレートの保存に失敗しました',
            loadFailed: 'テンプレートの読み込みに失敗しました',
            insertedPlaceholder: '[{title}]を挿入しました',
            readOnlyPermission: '権限不足：読み取り専用権限のみです',
        },
        systemTemplate: 'システムテンプレート',
        systemTemplateReadOnly: 'システムテンプレートは読み取り専用です',
        readOnly: '読み取り専用',
        clickToEditName: 'クリックして名前を編集',
    },
};
